import WhyChooseUsCard from "./WhyChooseUsCard";

export default WhyChooseUsCard;